import { useTranslation } from "react-i18next";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { useQuery } from "@tanstack/react-query";
import i18n from "../../../i18n";
import { getFiltersImprovementPlans } from "../api/getFilters";

type QueryFnType = typeof getFiltersImprovementPlans;
type UseFiltersOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useFiltersImprovementPlans = (config?: UseFiltersOptions) => {
    const { t } = useTranslation(["improvementPlan"]);
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ["filltersImprovementPlans", i18n.language],
        queryFn: async () => {
            const filters = await getFiltersImprovementPlans(t);

            // translate here
            return filters;
        }
    });
};